"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFileManagerPortalDataFetchSucceededAction = getFileManagerPortalDataFetchSucceededAction;
exports.fetchFileManagerPortalData = fetchFileManagerPortalData;
exports.getUpdateVidyardTosStatusSucceededAction = getUpdateVidyardTosStatusSucceededAction;
exports.getUpdateVidyardTosStatusFailedAction = getUpdateVidyardTosStatusFailedAction;
exports.getUpdateVidyardTosStatusAttemptedAction = getUpdateVidyardTosStatusAttemptedAction;
exports.getUpdateVidyardTosStatus = getUpdateVidyardTosStatus;
exports.syncUserSettingsToPortalMeta = exports.dualWriteUserSettingUpdate = exports.updatePortalMeta = void 0;

var ActionTypes = _interopRequireWildcard(require("./ActionTypes"));

var FileManagerPortalDataApi = _interopRequireWildcard(require("../api/PortalMeta"));

var _I18n = _interopRequireDefault(require("I18n"));

var _logging = require("../utils/logging");

var _Constants = require("../Constants");

var _PortalMetaCategoryIds = _interopRequireDefault(require("../enums/PortalMetaCategoryIds"));

var _portalMeta = require("../utils/portalMeta");

var _tracking = require("./tracking");

function getFileManagerPortalDataFetchSucceededAction(portalDataList) {
  return {
    type: ActionTypes.FETCH_FILE_MANAGER_PORTAL_DATA_SUCCEEDED,
    portalDataList: portalDataList
  };
}

function fetchFileManagerPortalData() {
  return function (dispatch) {
    return FileManagerPortalDataApi.fetchFileManagerPortalData().then(function (response) {
      dispatch(getFileManagerPortalDataFetchSucceededAction(response.get('objects')));
      return response.get('objects');
    }).catch(function (err) {
      (0, _logging.reportError)(err, {
        action: 'FETCH_FILE_MANAGER_PORTAL_DATA_FAILED'
      });
    });
  };
}

function getUpdateVidyardTosStatusSucceededAction(vidyardTosStatus) {
  return {
    type: ActionTypes.UPDATE_VIDYARD_TOS_STATUS_SUCCEEDED,
    vidyardTosStatus: vidyardTosStatus,
    meta: Object.assign({}, vidyardTosStatus === _Constants.VidyardTosStatus.ACCEPTED && {
      notification: {
        type: 'success',
        titleText: _I18n.default.text('FileManagerCore.notifications.updateVidyardToS.success.title'),
        message: _I18n.default.text('FileManagerCore.notifications.updateVidyardToS.success.message')
      }
    })
  };
}

function getUpdateVidyardTosStatusFailedAction() {
  return {
    type: ActionTypes.UPDATE_VIDYARD_TOS_STATUS_FAILED,
    meta: {
      notification: {
        type: 'danger',
        titleText: _I18n.default.text('FileManagerCore.notifications.updateVidyardToS.error.title'),
        message: _I18n.default.text('FileManagerCore.notifications.updateVidyardToS.error.message')
      }
    }
  };
}

function getUpdateVidyardTosStatusAttemptedAction() {
  return {
    type: ActionTypes.UPDATE_VIDYARD_TOS_STATUS_ATTEMPTED
  };
}

function getUpdateVidyardTosStatus(newVidyardTosStatus) {
  return function (dispatch) {
    dispatch(getUpdateVidyardTosStatusAttemptedAction());
    FileManagerPortalDataApi.updateVidyardTosStatus(newVidyardTosStatus).then(function () {
      dispatch(getUpdateVidyardTosStatusSucceededAction(newVidyardTosStatus));
    }, function () {
      dispatch(getUpdateVidyardTosStatusFailedAction());
    });
  };
}

var updatePortalMeta = function updatePortalMeta(category, apiValue) {
  return function (dispatch) {
    dispatch({
      type: ActionTypes.UPDATE_PORTAL_META_ATTEMPTED
    });
    FileManagerPortalDataApi.updatePortalMeta({
      category: category,
      category_value: apiValue
    }).then(function () {
      return dispatch({
        type: ActionTypes.UPDATE_PORTAL_META_SUCCEEDED,
        category: category,
        apiValue: apiValue
      });
    }).catch(function (err) {
      (0, _logging.reportError)(err, {
        type: ActionTypes.UPDATE_PORTAL_META_FAILED
      });
      dispatch({
        type: ActionTypes.UPDATE_PORTAL_META_FAILED
      });
    });
  };
};

exports.updatePortalMeta = updatePortalMeta;

var dismissCanvaPopup = function dismissCanvaPopup() {
  return function (dispatch) {
    return dispatch(updatePortalMeta(_PortalMetaCategoryIds.default.PICKER_CANVA_POPUP, _Constants.PickerCanvaPopupValues.DISMISSED));
  };
};

var acceptShutterstockTos = function acceptShutterstockTos() {
  return function (dispatch) {
    return dispatch(updatePortalMeta(_PortalMetaCategoryIds.default.SHUTTERSTOCK_TOS, _Constants.ShutterstockTosValues.ACCEPTED));
  };
};

var setShutterstockFolderId = function setShutterstockFolderId(folderId) {
  return function (dispatch) {
    return dispatch(updatePortalMeta(_PortalMetaCategoryIds.default.SHUTTERSTOCK_FOLDER_ID, folderId));
  };
};

var dualWriteUserSettingUpdate = function dualWriteUserSettingUpdate(updateAttrs) {
  return function (dispatch) {
    if (updateAttrs.hasSeenCanvaPopup) {
      dispatch(dismissCanvaPopup());
    }

    if (updateAttrs.signedShutterstock) {
      dispatch(acceptShutterstockTos());
    }

    if (updateAttrs.shutterstockFolderId) {
      dispatch(setShutterstockFolderId(updateAttrs.shutterstockFolderId));
    }
  };
};

exports.dualWriteUserSettingUpdate = dualWriteUserSettingUpdate;

var syncUserSettingsToPortalMeta = function syncUserSettingsToPortalMeta(userSettings, portalMetaList) {
  return function (dispatch) {
    if (userSettings.get('hasSeenCanvaPopup') && !(0, _portalMeta.getCategoryMap)(portalMetaList, _PortalMetaCategoryIds.default.PICKER_CANVA_POPUP)) {
      dispatch(dismissCanvaPopup());
      dispatch((0, _tracking.trackInteraction)('fileManagerManageFiles', 'sync-canva-popup'));
    }

    if (userSettings.get('signedShutterstock') && !(0, _portalMeta.getCategoryMap)(portalMetaList, _PortalMetaCategoryIds.default.SHUTTERSTOCK_TOS)) {
      dispatch(acceptShutterstockTos());
      dispatch((0, _tracking.trackInteraction)('fileManagerManageFiles', 'sync-shutterstock-tos'));
    }

    if (userSettings.get('shutterstockFolderId') && !(0, _portalMeta.getCategoryMap)(portalMetaList, _PortalMetaCategoryIds.default.SHUTTERSTOCK_FOLDER_ID)) {
      dispatch(setShutterstockFolderId(userSettings.get('shutterstockFolderId')));
      dispatch((0, _tracking.trackInteraction)('fileManagerManageFiles', 'sync-shutterstock-folder-id'));
    }
  };
};

exports.syncUserSettingsToPortalMeta = syncUserSettingsToPortalMeta;